import { TReduxActions, IGraphsState, TRegionGraph, TGraphValuesType } from '../../types/redux';
import { actionTypes } from '../../constants/actionTypes';

const defaultState = {
  data: null,
  isLoading: false,
  regionGraph: 0 as TRegionGraph,
  graphValuesType: 'thousands' as TGraphValuesType,
};

export function graphsReducer(state: IGraphsState = defaultState, action: TReduxActions) {
  switch (action.type) {
    case actionTypes.SET_GRAPHS_DATA:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
      };

    case actionTypes.SET_GRAPHS_LOADING:
      return {
        ...state,
        isLoading: true,
      };

    case actionTypes.TOGGLE_REGION_GRAPH:
      return {
        ...state,
        regionGraph: action.payload,
      };

    case actionTypes.TOGGLE_GRAPH_VALUES_TYPE:
      return {
        ...state,
        graphValuesType: action.payload,
      };

    default:
      return state;
  }
}
